import React from 'react'
import Seperator from '../component/seperator'
import { Link } from 'react-router-dom'
import PageUrlGuid from '../component/pageUrlGuid'



const Teammate = () => {
    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    همکاران ما
                </h1>
            </PageUrlGuid>
            {/* <div className='anj'>
                <div>
                    <img src="https://dl.newwebinar.ir/important/1.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/2.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/3.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/4.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/5.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/6.jpg" alt="" width={'16%'} height={"auto"} />
                </div>
                <div style={{ marginTop: "50px", display: "flex", justifyContent: "center" }}>
                    <img src="https://dl.newwebinar.ir/important/12.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/13.jpg" alt="" width={'16%'} height={"auto"} />
                    <img src="https://dl.newwebinar.ir/important/14.jpg" alt="" width={'16%'} height={"auto"} />
                </div>
            </div> */}
        </>
    )
}



export default Teammate